import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "frequencyLabel",
    "customFields",
    "readingConfig",
    "checkConfig",
    "actionConfig",
    "observationConfig",
    "proofDetails",
    "plantContext"
  ]

  updateItemType(event) {
    const type = event.target.value
    const configs = {
      reading: this.hasReadingConfigTarget ? this.readingConfigTarget : null,
      check: this.hasCheckConfigTarget ? this.checkConfigTarget : null,
      action: this.hasActionConfigTarget ? this.actionConfigTarget : null,
      observation: this.hasObservationConfigTarget ? this.observationConfigTarget : null
    }

    Object.entries(configs).forEach(([key, el]) => {
      if (el) el.classList.toggle("hidden", key !== type)
    })
  }

  updateFrequency(event) {
    const freq = event.target.value

    if (this.hasCustomFieldsTarget) {
      this.customFieldsTarget.classList.toggle("hidden", freq !== "custom")
    }

    if (this.hasFrequencyLabelTarget) {
      this.frequencyLabelTarget.textContent = this.frequencyText(freq)
    }
  }

  updateProofRequired(event) {
    if (this.hasProofDetailsTarget) {
      this.proofDetailsTarget.classList.toggle("hidden", !event.target.checked)
    }
  }

  updatePlantContext(event) {
    if (!this.hasPlantContextTarget) return
    const plantContext = this.plantContextTarget

    const selected = event.target.selectedOptions[0]
    if (!selected || !selected.value) {
      plantContext.classList.add("hidden")
      return
    }

    const mode = selected.dataset.operationsMode
    plantContext.classList.remove("hidden")

    const modeBadge = plantContext.querySelector("[data-role='mode-badge']")
    const modeAlert = plantContext.querySelector("[data-role='mode-alert']")

    if (modeBadge) {
      if (mode === "checklist_based") {
        modeBadge.textContent = "Checklist Based"
        modeBadge.className = "badge badge-info badge-sm"
      } else {
        modeBadge.textContent = "Shift Based"
        modeBadge.className = "badge badge-primary badge-sm"
      }
    }

    if (modeAlert) {
      modeAlert.classList.toggle("hidden", mode !== "checklist_based")
    }
  }

  frequencyText(freq) {
    const intervalValue = this.element.querySelector('[name="item[interval_value]"]')?.value || "?"
    const intervalUnit = this.element.querySelector('[name="item[interval_unit]"]')?.value || "hours"

    switch (freq) {
      case "shift": return "Every Shift"
      case "daily": return "Daily"
      case "weekly": return "Weekly"
      case "custom": {
        const unit = parseInt(intervalValue) === 1 ? intervalUnit.replace(/s$/, "") : intervalUnit
        return `Every ${intervalValue} ${unit}`
      }
      default: return freq
    }
  }
}
